import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import YbMockupHomeTopFilterHeader from "./TopFilterHeader";
import {
  DATE_RANGE_TYPE,
  getDateRangeByType,
} from "../home-dashboard-v2/DateHelper";
import { calculateInventoryData } from "../home-dashboard-v2/ReportsHelper";
import {
  transformHomeDashboardData,
  calculateTrendData,
  calculateSummaryData,
  calculateDistributionData,
} from "./ReportsHelper";
import HomeDashboardBodyForCst from "../home-dashboard-v2/HomeDashboardBodyForCst";

function _convertDateToYMD(date) {
  return moment(date).format("YYYY-MM-DD");
}

class HomeDashboardWrapperV4 extends React.Component {
  constructor(props) {
    super(props);

    const { resultData, isReseller, isHistoryDateRange } = this.props;
    const homeDashboardData = transformHomeDashboardData(resultData);

    const { publishers, gamNetworks, reportDateRange } = homeDashboardData;

    // Preselect the only publisher, otherwise "All"
    const selectedPubId =
      publishers.length === 1 ? _.get(publishers, [0, "id"], -1) : -1;

    // For Reseller
    let filteredNetworks = gamNetworks;
    if (selectedPubId !== -1) {
      filteredNetworks = _.filter(gamNetworks, { pubId: selectedPubId });
    }

    // Preselect the only network, otherwise "All"
    const selectedNetworkId =
      gamNetworks.length === 1 ? _.get(gamNetworks, [0, "id"], -1) : -1;

    const selectedYieldSetIds = -1; // All YieldSets
    const selectedRequestType = -1; // All Request Types
    const selectedCurrency = "USD";

    const currencies = _.keys(homeDashboardData.exchangeRates);
    const exchangeRates = homeDashboardData.exchangeRates[selectedCurrency];

    let dateRange = {};
    if (isHistoryDateRange) {
      // use reports date range
      dateRange = reportDateRange;
    } else {
      // default to "this month"
      const { startDate, endDate } = getDateRangeByType(
        DATE_RANGE_TYPE.DEFAULT
      );
      dateRange.startDate = startDate;
      dateRange.endDate = endDate;
    }
    const { startDate, endDate } = dateRange;

    this.state = {
      // filter
      selectedPubId,
      filteredNetworks,
      currencies,

      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      selectedCurrency,

      startDate,
      endDate,

      // data
      homeDashboardData,
      exchangeRates,

      isReseller,
      publishers,

      inventoryData: calculateInventoryData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
      }),
      summaryData: calculateSummaryData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
      distributionData: calculateDistributionData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
      trendData: calculateTrendData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
    };

    this.handleInventoryFilterChanged =
      this.handleInventoryFilterChanged.bind(this);
    this.handleDateRangeFilterChanged =
      this.handleDateRangeFilterChanged.bind(this);
    this.handleCurrencyChanged = this.handleCurrencyChanged.bind(this);
    this.handleProcessData = this.handleProcessData.bind(this);
  }

  handleInventoryFilterChanged({
    selectedPubId = this.state.selectedPubId,
    selectedNetworkId = this.state.selectedNetworkId,
    selectedYieldSetIds = this.state.selectedYieldSetIds,
    selectedRequestType = this.state.selectedRequestType,
  }) {
    console.log(
      "Inventory Filter changed: ",
      selectedPubId,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType
    );
    this.setState({
      selectedPubId,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      ...this.handleProcessData({
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
      }),
    });
  }

  handleDateRangeFilterChanged({ startDate, endDate }) {
    // Important! Convert a date object (with timezone) to just YYYY-MM-DD format
    const sd = _convertDateToYMD(startDate);
    const ed = _convertDateToYMD(endDate);

    console.log("Date Range Filter changed: ", sd, ed);
    this.setState({
      startDate: sd,
      endDate: ed,
      ...this.handleProcessData({
        startDate: sd,
        endDate: ed,
      }),
    });
  }

  handleCurrencyChanged(currency) {
    console.log("Currency changed: ", currency);
    const { homeDashboardData } = this.state;
    const exchangeRates = homeDashboardData.exchangeRates[currency];
    this.setState({
      selectedCurrency: currency,
      exchangeRates,
      ...this.handleProcessData({
        exchangeRates,
      }),
    });
  }

  handleProcessData({
    homeDashboardData = this.state.homeDashboardData,
    startDate = this.state.startDate,
    endDate = this.state.endDate,
    selectedPubId = this.state.selectedPubId,
    selectedNetworkId = this.state.selectedNetworkId,
    selectedYieldSetIds = this.state.selectedYieldSetIds,
    selectedRequestType = this.state.selectedRequestType,
    exchangeRates = this.state.exchangeRates,
  }) {
    const stateData = {};
    if (
      selectedPubId !== this.state.selectedPubId ||
      selectedNetworkId !== this.state.selectedNetworkId ||
      selectedYieldSetIds !== this.state.selectedYieldSetIds ||
      selectedRequestType !== this.state.selectedRequestType
    ) {
      stateData.inventoryData = calculateInventoryData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
      });
    }
    return {
      ...stateData,
      summaryData: calculateSummaryData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
      distributionData: calculateDistributionData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
      trendData: calculateTrendData({
        homeDashboardData,
        selectedPubId,
        selectedNetworkId,
        selectedYieldSetIds,
        selectedRequestType,
        startDate,
        endDate,
        exchangeRates,
      }),
    };
  }

  render() {
    const {
      homeDashboardData,

      isReseller,
      selectedPubId,
      publishers,
      filteredNetworks,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      inventoryData,
      summaryData,
      startDate,
      endDate,
      distributionData,
      trendData,
      currencies,
      selectedCurrency,
    } = this.state;

    if (!homeDashboardData) {
      return <div>No Data</div>;
    }

    return (
      <>
        <div className="bg-white">
          <div className="shadow sticky top-0 z-40">
            <YbMockupHomeTopFilterHeader
              isReseller={isReseller}
              selectedPubId={selectedPubId}
              publishers={publishers}
              networks={filteredNetworks}
              selectedNetworkId={selectedNetworkId}
              selectedYieldSetIds={selectedYieldSetIds}
              yieldSets={homeDashboardData.yieldSets}
              handleInventoryFilterChanged={this.handleInventoryFilterChanged}
              selectedRequestType={selectedRequestType}
              requestTypes={homeDashboardData.requestTypes}
              handleRequestTypeChanged={this.handleInventoryFilterChanged}
              currencies={currencies}
              selectedCurrency={selectedCurrency}
              handleCurrencyChanged={this.handleCurrencyChanged}
              startDate={startDate}
              endDate={endDate}
              handleDateRangeFilterChanged={this.handleDateRangeFilterChanged}
            ></YbMockupHomeTopFilterHeader>
          </div>

          <div className="px-12 py-6">
            <HomeDashboardBodyForCst
              updatedTime={homeDashboardData.updatedTime}
              selectedPubId={selectedPubId}
              selectedNetworkId={selectedNetworkId}
              selectedYieldSetIds={selectedYieldSetIds}
              selectedRequestType={selectedRequestType}
              inventoryData={inventoryData}
              summaryData={summaryData}
              startDate={startDate}
              endDate={endDate}
              distributionData={distributionData}
              trendData={trendData}
              selectedCurrency={selectedCurrency}
            ></HomeDashboardBodyForCst>
          </div>
        </div>
      </>
    );
  }
}

export default HomeDashboardWrapperV4;
